import { Logger } from 'services/logger';

import { contentstackLivePreviewSdk } from 'utils/contentstackLivePreviewSdk';

export const fetchLivePreviewData = async ({
  hash,
  pageUid,
  refs,
  pageType,
  timestamp,
}: {
  hash: string;
  pageUid: string;
  refs: string[];
  pageType: string;
  timestamp?: string | null;
}) => {
  try {
    const url = `
    https://rest-preview.contentstack.com/v3/content_types/${pageType}/entries/${pageUid}?${refs}
    `;
    const response = await fetch(url, {
      headers: {
        api_key: contentstackLivePreviewSdk.config.api_key,
        preview_token: contentstackLivePreviewSdk.config.live_preview.preview_token,
        live_preview: hash,
        ...(timestamp && { preview_timestamp: timestamp }),
      },
    });
    const data = await response.json();

    return data?.entry;
  } catch (err) {
    Logger.error('Error fetching live preview data: ', err);

    return null;
  }
};
